import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/rotate-left.svg'
import _imports_1 from '../../assets/img/icons/add-circle.svg'
import _imports_2 from '../../assets/img/icons/download.svg'
import _imports_3 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row gx-0 mb-50" }
const _hoisted_3 = { class: "col-md-6 offset-md-6" }
const _hoisted_4 = { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_ChooseForm = _resolveComponent("ChooseForm")!
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_PaperSize = _resolveComponent("PaperSize")!
  const _component_BarcodeWrapper = _resolveComponent("BarcodeWrapper")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Print Barcode" }),
      _createVNode(_component_ChooseForm),
      _createVNode(_component_SelectedProducts),
      _createVNode(_component_PaperSize),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              type: "button",
              class: "btn style-four"
            }, [
              _createTextVNode(" Reset "),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Image"
              })
            ], -1)),
            _createElementVNode("button", {
              class: "btn style-one",
              id: "create-barcode",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleBarcode.onChange && _ctx.toggleBarcode.onChange(...args)))
            }, _cache[1] || (_cache[1] = [
              _createTextVNode(" Create Barcode"),
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Image"
              }, null, -1)
            ])),
            _cache[3] || (_cache[3] = _createElementVNode("a", {
              class: "btn style-five upload-btn px-xxl-6",
              onclick: "window.print();"
            }, [
              _createTextVNode(" Print"),
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Image"
              })
            ], -1))
          ])
        ])
      ]),
      _createVNode(_component_BarcodeWrapper),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\" data-v-3b9a67ee><div class=\"offcanvas-body p-0\" data-v-3b9a67ee><div class=\"delete-success\" data-v-3b9a67ee><img src=\"" + _imports_3 + "\" alt=\"Image\" data-v-3b9a67ee><span class=\"text-white fw-medium\" data-v-3b9a67ee> Your product is deleted from the list. </span></div></div></div>", 1))
  ], 64))
}